var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import '../../../scss/paywall/block_multiple_users_modal.scss';
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import * as Modal from "react-modal";
import { fetchApi, translate } from "../helpers";
import { updateFingerprint } from "../paywallFingerprint";
import { HttpMethods } from "tagwalk-api-client/assets/js/common/enums";
export var PaywallBlockMultipleUsers = function (_a) {
    var subscription = _a.subscription;
    var _b = useState(true), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(false), explanationVisible = _d[0], setExplanationVisible = _d[1];
    var explanationScreenRef = useRef(null);
    var actionScreenRef = useRef(null);
    var body = document.querySelector('body');
    if (!body) {
        return null;
    }
    Modal.setAppElement(body);
    var disableScroll = function () {
        document.addEventListener('wheel', disableEvent, { passive: false });
        document.addEventListener('touchmove', disableEvent, { passive: false });
        document.addEventListener('keydown', function (e) {
            var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Space', 'PageUp', 'PageDown', 'Home', 'End'];
            if (keys.includes(e.code) === true) {
                e.preventDefault();
                return false;
            }
            return true;
        });
    };
    var disableRightClick = function () {
        document.addEventListener('contextmenu', disableEvent, { passive: false });
    };
    var disableEvent = function (e) {
        var modalBody = document.querySelector('.modal-body');
        if (!modalBody) {
            return;
        }
        var leftBlock = modalBody.querySelector('.left-block');
        if (leftBlock && leftBlock.contains(e.target)) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
    };
    useEffect(function () {
        disableScroll();
        disableRightClick();
    }, []);
    var scrollToExplanation = function () {
        var _a;
        setExplanationVisible(true);
        (_a = explanationScreenRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    var handleScroll = function (e) {
        var _a;
        var explanationScreen = explanationScreenRef.current;
        if (!explanationScreen) {
            return;
        }
        var scrollTop = explanationScreen.scrollTop;
        if (scrollTop === 0 && e.deltaY < 0) {
            setExplanationVisible(false);
            (_a = actionScreenRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        }
    };
    var handleTouch = function (e) {
        var _a;
        var explanationScreen = explanationScreenRef.current;
        if (!explanationScreen) {
            return;
        }
        var scrollTop = explanationScreen.scrollTop;
        if (scrollTop === 0) {
            setExplanationVisible(false);
            (_a = actionScreenRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        }
    };
    useEffect(function () {
        var explanationScreen = explanationScreenRef.current;
        if (!explanationScreen) {
            return;
        }
        explanationScreen.addEventListener('wheel', handleScroll);
        explanationScreen.addEventListener('touchmove', handleTouch);
        return function () {
            explanationScreen === null || explanationScreen === void 0 ? void 0 : explanationScreen.removeEventListener('wheel', handleScroll);
            explanationScreen === null || explanationScreen === void 0 ? void 0 : explanationScreen.removeEventListener('touchmove', handleTouch);
        };
    }, [explanationVisible]);
    var manageFingerprintUpdate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4, updateFingerprint(subscription)];
                case 1:
                    _a.sent();
                    setIsModalOpen(false);
                    setIsLoading(false);
                    return [2];
            }
        });
    }); };
    var handleLogoutRedirect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchApi('security_request_authentication', HttpMethods.get, {
                        'message': translate('block_multiple_connections_modal.flash.force_relogin', {}, 'paywall'),
                        'route': 'membership_index'
                    })];
                case 1:
                    response = _a.sent();
                    if (response) {
                        window.location.href = response.url;
                    }
                    return [2];
            }
        });
    }); };
    return (React.createElement(Modal, { isOpen: isModalOpen, className: "tds" },
        React.createElement("div", { id: "paywallBlockModalContent", className: "modal " + (isModalOpen ? 'modal--open' : '') },
            React.createElement("div", { className: "modal-body grid-2 " + (explanationVisible ? 'bg-white' : 'bg-beige') },
                React.createElement("div", { className: "left-block" },
                    React.createElement("div", { className: "actionScreen " + (explanationVisible ? 'hidden' : ''), ref: actionScreenRef },
                        React.createElement("div", { className: "flex-center" },
                            React.createElement("i", { className: "iconoir-warning-circle" })),
                        React.createElement("p", { className: "title" }, translate('block_multiple_connections_modal.title', {}, 'paywall')),
                        React.createElement("p", { className: "subtitle" }, translate('block_multiple_connections_modal.subtitle', {}, 'paywall')),
                        React.createElement("button", { id: "continueHereBtn", className: "btn", onClick: function () { return manageFingerprintUpdate(); }, disabled: isLoading }, isLoading ? React.createElement("div", { className: "spinner" }) : translate('block_multiple_connections_modal.action.continue', {}, 'paywall')),
                        React.createElement("button", { className: "btn btn-secondary", onClick: handleLogoutRedirect }, translate('block_multiple_connections_modal.action.subscribe', {}, 'paywall')),
                        React.createElement("button", { className: "btn-link", onClick: scrollToExplanation }, translate('block_multiple_connections_modal.explanation_link', {}, 'paywall'))),
                    React.createElement("div", { ref: explanationScreenRef, className: "explanationScreen " + (explanationVisible ? 'visible' : 'hidden') },
                        React.createElement("div", { className: "explanation-block" },
                            React.createElement("p", { className: 'explanation-title' }, translate('block_multiple_connections_modal.explanation.title.log_out', {}, 'paywall')),
                            React.createElement("p", { dangerouslySetInnerHTML: { __html: translate('block_multiple_connections_modal.explanation.description.log_out', {}, 'paywall') } })),
                        React.createElement("div", { className: "explanation-block" },
                            React.createElement("p", { className: 'explanation-title' }, translate('block_multiple_connections_modal.explanation.title.need_collaboration', {}, 'paywall')),
                            React.createElement("p", null, translate('block_multiple_connections_modal.explanation.description.need_collaboration', {}, 'paywall'))),
                        React.createElement("div", { className: "explanation-block" },
                            React.createElement("p", { className: 'explanation-title' }, translate('block_multiple_connections_modal.explanation.title.change_password', {}, 'paywall')),
                            React.createElement("p", null, translate('block_multiple_connections_modal.explanation.description.change_password', {}, 'paywall')),
                            React.createElement("br", null),
                            React.createElement("p", { dangerouslySetInnerHTML: { __html: translate('block_multiple_connections_modal.explanation.description.continue_working', {}, 'paywall') } })))),
                React.createElement("div", { className: "right-block" })))));
};
